import { env } from 'next-runtime-env';

export const SETTINGS = {
  public: {
    tmsToken: env('NEXT_PUBLIC_TMS_TOKEN'),
    basePath: env('NEXT_PUBLIC_BASE_PATH'),
    televetSvc: env('NEXT_PUBLIC_URL_TELEVET_SVC'),
    urlTelevetWeb: env('NEXT_PUBLIC_URL_TELEVET_WEB'),
    pathHubWeb: env('NEXT_PUBLIC_PATH_HUB_WEB'),
    urlHubWeb: env('NEXT_PUBLIC_URL_HUB_WEB'),
    urlAuthWeb: env('NEXT_PUBLIC_URL_AUTH_WEB'),
    urlAccountWeb: env('NEXT_PUBLIC_URL_ACCOUNT_WEB'),
    urlAccountSvc: env('NEXT_PUBLIC_URL_ACCOUNT_SVC'),
    urlPlanWeb: env('NEXT_PUBLIC_URL_PLAN_WEB'),
    urlContractLegacySvc: env('NEXT_PUBLIC_URL_CONTRACT_LEGACY_SVC'),
    televetsUrl: env('NEXT_PUBLIC_TELEVETS_URL'),
    televetsToken: env('NEXT_PUBLIC_TELEVETS_TOKEN'),
    televetsClientId: env('NEXT_PUBLIC_TELEVETS_CLIENT_ID'),
    urlSystemEventSvc: env('NEXT_PUBLIC_URL_SYSTEM_EVENT_SVC'),
  },
  server: {
    basePath: env('BASE_PATH'),
  },
};
